import { useTranslation } from 'react-i18next';
import { DialogTitle } from '@shared/typography/title';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { UserFormView } from '@app/feature/user/generic-user/user-form/user-form.view';
import { Snackbar } from '@shared/snackbar/snackbar';
import { useUpdateAdminMutation } from '@service/admin.service';
import { BackOfficeUserModel } from '@delmonicos/shared-sdk/libs/emsp/src/libs/back-office/src/models/users/back-office-user.model';
import { UpdateAdminModel } from '@delmonicos/shared-sdk/libs/emsp/src/libs/back-office/src/models/users/update-user.model';

interface AdminUpdateProps {
  admin: BackOfficeUserModel;
  onCancel: () => void;
  onSuccess: () => void;
  onError: () => void;
}

export function AdminUpdate({
  admin,
  onCancel,
  onSuccess,
  onError,
}: AdminUpdateProps): React.JSX.Element {
  const { t } = useTranslation();

  const [handleUpdateAdmin, { isLoading, isError, error }] =
    useUpdateAdminMutation();

  const handleSubmit = (updatedAdmin: UpdateAdminModel) => {
    if (!admin.id) {
      onError();
      return;
    }

    handleUpdateAdmin({
      id: admin.id,
      ...updatedAdmin,
    })
      .unwrap()
      .then(onSuccess)
      .catch(onError);
  };

  return (
    <>
      <DialogTitle icon={<EditOutlinedIcon />}>
        {t('user.admin.update.title')}
      </DialogTitle>

      <UserFormView
        defaultValues={admin}
        formType="update"
        onSubmit={handleSubmit}
        pending={isLoading}
        onCancel={onCancel}
      />

      {isError && (
        <Snackbar
          variant="error"
          message={t('error.patch-user-mutation', { error })}
        />
      )}
    </>
  );
}
